import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import Seo from "../components/site/Seo";
import { Logo } from "../components/site/Logo";
import { api, errorMessage } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-moss/20 bg-white px-4 py-3.5 outline-none focus:border-moss";
  return (
    <main className="min-h-screen grid place-items-center bg-forest px-5" data-testid="page-admin-login">
      <Seo title="Espace pro | Moustique Bordeaux" description="Espace professionnel" path="/admin/login" noindex />
      <form onSubmit={submit} className="w-full max-w-md rounded-[28px] bg-cream p-8 md:p-10 space-y-5" data-testid="admin-login-form">
        <Logo />
        <h1 className="font-display text-3xl font-extrabold text-forest flex items-center gap-3"><Lock className="w-6 h-6" />Espace demandes</h1>
        <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className={field} data-testid="admin-email-input" />
        <input type="password" required value={password} onChange={e => setPassword(e.target.value)} placeholder="Mot de passe" className={field} data-testid="admin-password-input" />
        {error && <p className="text-sm font-semibold text-red-700" data-testid="admin-login-error">{error}</p>}
        <button className="btn btn-forest w-full" disabled={loading} data-testid="admin-login-submit">{loading && <Loader2 className="w-4 h-4 animate-spin" />}Se connecter</button>
      </form>
    </main>
  );
}
